<style lang="scss" scoped>
    .headform .vview-formitem{
        margin-bottom: 0 !important
    }
    .button-container {
        padding: 10px 0;
        text-align: left;

        .top-button {
            margin: 0 5px;
        }
    }
    .modal-a {
        .content {
            .content-text {
                text-align: center;
                line-height: 60px;
            }
            .button-area {
                text-align: right;
            }
            .button {
                margin: 5px;
            }
        }
    }
    .absolute-button {
        position: absolute;
        top: 3px;
        right: 25px;
    }
    .flex-right {
        display: flex;
        justify-content: flex-end;

        .margin-btn {
            margin: 10px;
        }
    }
    .exception-area {
        position: absolute;
        left: 66%;
        top: 60px;
        text-align: left;
    }
</style>
<template>
    <div>
        <div class="button-container" v-if="type === 'query' && hasData">
            <vButton class="margin-right-10" v-if="handleAuth('fbb.logisticsHead.create') && (formData.orderStatus == 0 || formData.orderStatus == 2)" theme="primary" @click="submitshenhe">{{$t('fbb.inbound.submit_audit', { defaultValue: '提交审核' })}}</vButton>
            <div class="inline" v-for="item in btnList" :key="item.key">
                <vButton class="top-button" v-if="!item.hide" :theme="item.theme" @click="handleOperate(item)">{{item.text}}</vButton>
            </div>
            <div class="pull-right">
                <vButton theme="primary" @click="refreshPage">{{$t('global.common.refresh', { defaultValue: '刷新' })}}</vButton>
            </div>
        </div>
        <compWrapper :title="$t('fbb.headlogistics.base_info', { defaultValue: '基础信息' })" theme="primary">
            <vButton v-if="type === 'query'" class="absolute-button" theme="success" @click="exportExcel">{{$t('fbb.headlogistics.export_order', { defaultValue: '导出订舱单' })}}</vButton>
            <div class="exception-area" v-if="exceptionItem.value !== 0">
                <div class="font-weight color-error">{{exceptionItem.label}}</div>
            </div>
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
                placeholder="--"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
            <template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit">{{$t('fbb.inbound.save_draft', { defaultValue: '保存为草稿' })}}</vButton>
                <vButton v-if="handleAuth('fbb.logisticsHead.create')" class="margin-right-20" theme="primary" @click="submitshenhe">{{$t('fbb.inbound.submit_audit', { defaultValue: '提交审核' })}}</vButton>
				<vButton class="margin-right-20" @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
			</template>
        </compWrapper>
        <!-- 待订舱及之后的状态才显示-标准 -->
        <compWrapper :title="$t('fbb.headlogistics.shipment_info', { defaultValue: '发运信息' })" theme="info" v-if="formData.carrierType === 0 && formData.orderStatus >= 6">
                <compFormQuery v-if="type=='query'" class="margin-layout" :value="formData" :formdata="getDespatch" placeholder="--"></compFormQuery>
        </compWrapper>
        <!-- 审核之后的状态才显示-其他 -->
        <compWrapper :title="$t('fbb.headlogistics.shipment_info', { defaultValue: '发运信息' })" theme="info" v-else-if="formData.carrierType === 1 && formData.orderStatus >= 3">
                <compFormQuery v-if="type=='query'" class="margin-layout" :value="formData" :formdata="getDespatch" placeholder="--"></compFormQuery>
        </compWrapper>
        <!-- 有进口商的才显示 -->
        <compWrapper :title="$t('fbb.headlogistics.importer_info', { defaultValue: '进口商信息' })" theme="info" v-if="type === 'query'">
                <compFormQuery v-if="type=='query'" class="margin-layout" :value="formData" :formdata="getImporter" placeholder="--"></compFormQuery>
        </compWrapper>
        <compWrapper :title="$t('fbb.headlogistics.connection_type', { defaultValue: '联系方式' })" theme="info">
            <div v-for="(item,index) in factorylist" :key="index" style="border-bottom:1px solid #bbb">
                <div class="margin-left-15 margin-top-15">{{$t('fbb.headlogistics.factory_connection', { defaultValue: '工厂联系方式' })}}</div>
                <compFormQuery v-if="type=='query'" class="margin-layout" :value="factorylist[index]" :formdata="getFactory"></compFormQuery>
                <compFormEdit v-else ref="formfactory" class="margin-layout" v-model="factorylist[index]" :formdata="getFactory"></compFormEdit>
                <div class="margin-left-15 margin-top-15">{{$t('fbb.headlogistics.deliver_connection', { defaultValue: '发货方联系方式' })}}</div>
                <compFormQuery v-if="type=='query'" class="margin-layout" :value="factorylist[index]" :formdata="getContent"></compFormQuery>
                <compFormEdit v-else ref="formcontent" class="margin-layout" v-model="factorylist[index]" :formdata="getContent"></compFormEdit>
            </div>
        </compWrapper>
        <compWrapper :title="$t('fbb.headlogistics.inbound', { defaultValue: '入库单' })" theme="warning" v-if="inboundlist.length>0">
            <div v-for="(item,index) in inboundlist" :key="index" style="margin-bottom:2px solid #333">
                <div>
                    <vCol span="6">
                        <div class="margin-top-15 margin-left-30 font-bold font-14">{{$t('fbb.headlogistics.inbound', { defaultValue: '入库单' })}} {{item.orderNo}}</div>
                    </vCol>
                    <vCol span="3">
                        <div class="margin-top-15 margin-left-30 font-bold font-14">{{$t('global.common.status', { defaultValue: '状态' })}}: {{getOrderStatus(item.orderStatus)}}</div>
                    </vCol>
                    <vCol span="3" v-if="getException(item).value !== 0">
                        <div class="margin-top-15 margin-left-30 font-bold font-14 color-error">{{getException(item).label}}</div>
                    </vCol>
                    <vCol span="12">
                        <div class="flex-right">
                            <vButton v-if="getException(item).value !== 0 && formData.logisticsType === 'transfer'" class="margin-btn" theme="success" @click="handleOperate(
                                {
                                    title: $t('fbb.headlogistics.huifuzhengchang', { defaultValue: '恢复正常' }),
                                    component: 'compModal',
                                    data: {
                                        type: 'backToNormal',
                                        childId: item.id,
                                        isSub: true,
                                    },
                                    type: 33,
                                })">{{$t('fbb.headlogistics.huifuzhengchang', { defaultValue: '恢复正常' })}}</vButton>
                            <vButton v-if="item.orderStatus === 8" class="margin-btn" theme="primary" @click="handleOperate(
                                {
                                    title: $t('fbb.headlogistics.yuyue', { defaultValue: '预约' }),
                                    component: 'compModal',
                                    data: {
                                        type: 'appointment',
                                        childId: item.id,
                                        isSub: true
                                    },
                                    type: 17,
                                }
                            )">{{$t('fbb.headlogistics.yuyue', { defaultValue: '预约' })}}</vButton>
                            <vButton v-if="item.orderStatus === 16 || item.orderStatus === 8" class="margin-btn" theme="success" @click="handleOperate(
                                {
                                    title: $t('fbb.headlogistics.tuotou', { defaultValue: '妥投' }),
                                    component: 'compModal',
                                    data: {
                                        type: 'delivered',
                                        childId: item.id,
                                        isSub: true
                                    },
                                    type: 18
                                }
                            )">{{$t('fbb.headlogistics.tuotou', { defaultValue: '妥投' })}}</vButton>
                        </div>
                    </vCol>
                </div>
                <vForm :labelWidth="120" class="clearfix headform">
                    <vCol span="12">
                        <vFormItem :label="$t('fbb.headlogistics.customer_depot', { defaultValue: '目的仓' })">
                            {{item.warehouseCode || '--'}}
                        </VFormItem>
                    </vCol>
                    <vCol span="12" v-if="item.warehouseType == 2">
                        <vFormItem v-if="type=='query'" :label="$t('fbb.headlogistics.target_address', { defaultValue: '目的地址' })" >
                            <span >{{item.addressCode}}</span>
                        </VFormItem>
                        <vFormItem v-else :label="$t('fbb.headlogistics.target_address', { defaultValue: '目的地址' })" :rules="required" prop="addressCode">
                            <Select clearable filterable v-model="inboundlist[index].addressCode" @on-change="changeFlag(inboundlist[index].addressCode,index)">
                                <Option v-for="json in addressCodeList" :value="json.code" :key="json.code">{{ json.code }}</Option>
                            </Select>
                        </VFormItem>
                    </vCol>
                    <vCol span="24">
                        <vFormItem :label="$t('fbb.headlogistics.warehouse_address', { defaultValue: '仓库地址' })">
                            <span v-if="item.addressCode == ''">--</span>
                            <span v-else-if="item.addressEntity">
                                {{item.addressEntity.country || ''}},{{item.addressEntity.state|| ''}},{{item.addressEntity.city|| ''}},{{item.addressEntity.address|| ''}},{{item.addressEntity.linkman|| ''}},{{item.addressEntity.phone|| ''}}
                            </span>
                            <span v-else>--</span>
                        </VFormItem>
                    </vCol>
                    <!-- 亚马逊仓 -->
                    <div v-if="item.warehouseType === 2">
                        <vCol span="12">
                            <vFormItem v-if="type === 'edit'" style="height: 42px;" label="Shipment id" :rules="required" prop="shipmentId">
                                <vInput v-model="inboundlist[index].shipmentId"></vInput>
                            </vFormItem>
                            <vFormItem v-else-if="type === 'query'" style="height: 42px;" label="Shipment id">
                                <div class="font-weight">{{inboundlist[index].shipmentId}}</div>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem v-if="type === 'edit'" style="height: 42px;" label="Reference id" :rules="required" prop="referenceId">
                                <vInput v-model="inboundlist[index].referenceId"></vInput>
                            </vFormItem>
                            <vFormItem v-else-if="type === 'query'" style="height: 42px;" label="Reference id">
                                <div class="font-weight">{{inboundlist[index].referenceId}}</div>
                            </vFormItem>
                        </vCol>
                    </div>
                    <vCol span="8">
                        <vFormItem :label="$t('fbb.headlogistics.total_cases', { defaultValue: '总箱数' })">
                            {{item.totalQuantity}}
                        </VFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem :label="$t('fbb.headlogistics.total_volumn', { defaultValue: '总体积' }) + '(CBM)'">
                            {{item.totalVolume}}
                        </VFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem :label="$t('fbb.headlogistics.total_weight', { defaultValue: '总重量' }) + '(kg)'">
                            {{item.totalWeight}}
                        </VFormItem>
                    </vCol>
                </vForm>
                <vTable
                class="margin-left-20 margin-right-20 margin-bottom-20"
				:columns="inboundcolumns"
				:data="item.logisticsDetailEntities"
				size="small"
				ref="tablequery"
				border></vTable>
            </div>
        </compWrapper>
        <compWrapper :title="$t('fbb.headlogistics.logistics_history', { defaultValue: '物流历史' })" v-if="type==='query' && needRefresh" theme="gray">
            <compSeelog class="margin-15" :orderid="id" :seedetail="type"></compSeelog>
        </compWrapper>
        <!-- <div class="text-right" v-if="type=='query' && (formData.orderStatus == 0 || formData.orderStatus == 2)" style="background:#fff">
            <vButton class="margin-right-20" v-if="handleAuth('fbb.logisticsHead.create')" theme="primary" @click="submitshenhe">提交审核</vButton>
        </div> -->
        <vModal
            class="hidefooter modal-a"
            v-model="operate.show"
            :mask-closable='false'
            v-bind="operate"
            :width="operate.width"
            :showFooter="false"
        >
        <div class="content" v-if="!operate.component">
            <div class="content-text">{{operate.contentText}}</div>
            <div class="button-area">
                <vButton class="button" theme="primary" @click="operate.ok">{{$t('global.datepicker.confirm', { defaultValue: '确认' })}}</vButton>
                <vButton class="button" @click="operate.cancel ? operate.cancel : operate.show = false">{{operate.cancelText ? operate.cancelText : $t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
            </div>
        </div>
        <component
            v-else
            :is="operate.component"
            @on-close="operate.show=false"
            @on-success="refreshPage"
            v-on="operate.on"
            v-bind="operate.props"
        ></component>
        
        </vModal>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { HttpSeeLogisticsOne,HttpUpdateLogisticsOne,HttpAddressList,HttpSubmitSaveLogisticsOne, HttpUpdateLogistics } from "@/service/headlogistics";
import { mapState, mapGetters } from 'vuex';
import mixinlist from '../mixin'
import compSeelog from '../newSeelogistics'
import comExam from './comExam'
import comExamOther from './comExamOther'
import compModal from './compModal'
import compExportExcel from './compExportExcel'
import compChangeDate from './comChangeDate'
import compExpectWarehouseDate from './compExpectWarehouseDate'
import compCost from "./comcost.vue"
export default {
    mixins: [mixinlist],
    props:['activeid','querytype'],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        compSeelog,
        comExam,
        comExamOther,
        compModal,
        compExportExcel,
        compChangeDate,
        compExpectWarehouseDate,
        compCost
	},
    data(){
        return {
            loading: true,
            hasData: false,
            operate: {
                show: false,
                contentText: ''
            },
            orderType: 0,
            type: this.$route.params.type,
            id: this.$route.query.id,
            factorylist:[],
            inboundlist:[
                {addressCode:""},
            ],
            datalist:[],
            addressCodeList:[],
            required: [{
                required: true,
                message: this.$t('global.common.information_empty', { defaultValue: "该信息不能为空,请填写" })
            }],
            formData:{
                currency: 'USD'
            },
            flag:false,
            isNormal: true,
            exceptionItem: {},
            btnList: [],
            needRefresh: true
        }
    },
    created(){
        this.update()
    },
    computed:{
        ...mapGetters('common', ['getCurrencyList']),
        getBase(){
            return [
                {
                    label: this.$t('fbb.headlogistics.prelogistics_number', { defaultValue: '头程单号' }),
                    key: "preLogisticsNo",
                    required:false,
                    query:this.type!='add',
                },
                {
                    label: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: "orderStatus",
                    tag:'vSelect',
                    options:this.queryOrderStatusList,
                    required:false,
                    query:this.type!='add'
                },
                {
                    label: this.$t('fbb.headlogistics.logistics_type', { defaultValue: '发运类型' }),
                    key: "logisticsType",
                    tag:'vSelect',
                    options: [
                        {value:'transfer',label: this.$t('fbb.headlogistics.logistics_type_transfer', { defaultValue: '中转' })},
                        {value:'through',label: this.$t('fbb.headlogistics.logistics_type_through', { defaultValue: '直达' })}
                    ],
                    required:false,
                    show: this.type == 'query',
                    query:this.type!='add'
                },
                {
                    label: this.$t('fbb.inbound.storage_number', { defaultValue: '入库计划单号' }),
                    key: "subLogisticsNos",
                    required:false,
                    query:this.type!='add'
                },
                {
                    label: this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' }),
                    key: "associatedNo",
                    required:false
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: "projectName",
                    required:false,
                    query:this.type!='add'
                },
                {
                    label: this.$t('fbb.headlogistics.forwarder_type', { defaultValue: '贷代类型' }),
                    key: "carrierType",
                    tag:'vSelect',
                    options:[
                        {value:0,label: this.$t('fbb.headlogistics.carrier_type_standard', { defaultValue: '标准' })},
                        {value:1,label: this.$t('fbb.headlogistics.carrier_type_other', { defaultValue: '其他' })},
                    ],
                },
                {
                    label: this.$t('fbb.headlogistics.expect_stuffing_date', { defaultValue: '预计交货日期' }),
                    key: "expectStuffingDate",
                    tag:'vDatepicker',
                    props:{
                        format:'yyyy-mm-dd',
                        confirm:false,
                    },
                    required:true,
                },
                {
                    label: this.$t('fbb.headlogistics.factory_batch_number', { defaultValue: '工厂批次号' }),
                    key: "factoryBatchNo",
                    required:false,
                },
                //  {
                //     label: '预计开船日期',
                //     tag: "vDatepicker",
                //     key: "estimateSailAt",
                //     props: {
                //         format: 'yy-mm-dd',
                //     },
                //     required:true,
                // },
                {
                    label: this.$t('global.common.currency', { defaultValue: '币种' }),
                    key: "currency",
                    tag:'vSelect',
                    options:this.getCurrencyList.map(item=>{
                        return {
                            value:item,
                            label:item,
                        }
                    }),
                },
                {
                    label: this.$t('global.common.notes', { defaultValue: '备注' }),
                    key: "remark",
                    required:false,
                },
                {
                    label: this.$t('fbb.headlogistics.forwarder_warehouse', { defaultValue: '中转仓' }),
                    key: 'forwarderWarehouseCode',
                    show: this.type === 'query' && this.formData.logisticsType === 'transfer',
                    render: (h) => {
                        if (!this.formData.forwarderWarehouseCode) {
                            return <div>Other</div>
                        }
                        else {
                            return <div>{this.formData.forwarderWarehouseCode}</div>
                        }
                    }
                }
            ]
        },
        getFactory(){
            return [
                {
                    label: this.$t('fbb.headlogistics.factory_name', { defaultValue: '工厂名称' }),
                    key: "factoryName",
                },
                {
                    label: this.$t('fbb.headlogistics.factory_address', { defaultValue: '工厂地址' }),
                    key: "factoryAddress",
                },
                {
                    label: this.$t('fbb.headlogistics.factory_contact', { defaultValue: '联系人' }),
                    key: "factoryContact",
                },
                {
                    label: this.$t('fbb.inbound.contact_phone', { defaultValue: '联系电话' }),
                    key: "factoryPhone",
                },
            ]
        },
        getContent(){
            return [
                {
                    label: this.$t('fbb.inbound.shipper_name', { defaultValue: '发货方名称' }),
                    key: "senderName",
                },
                {
                    label: this.$t('fbb.inbound.shipper_address', { defaultValue: '发货方地址' }),
                    key: "senderAddress",
                },
                {
                    label: this.$t('fbb.headlogistics.factory_contact', { defaultValue: '联系人' }),
                    key: "senderContact",
                },
                {
                    label: this.$t('fbb.inbound.contact_phone', { defaultValue: '联系电话' }),
                    key: "senderPhone",
                },
            ]
        },
        getDespatch () {
            return [{
                // label: '物流单号/提单号',
                label: `${this.$t('fbb.headlogistics.logistics_number_logistics', { defaultValue: '物流单号' })}/${this.$t('fbb.headlogistics.logistics_number', { defaultValue: '提单号' })}`,
                key: 'logisticsNo',
            }, {
                label: this.$t('fbb.headlogistics.forwarder', { defaultValue: '货代公司' }),
                key: 'forwarderName',
            }, {
                label: this.$t('fbb.headlogistics.ship_port', { defaultValue: '发运港' }),
                key: 'shipPort'
            }, {
                label: this.$t('fbb.headlogistics.purpose_port', { defaultValue: '目的港' }),
                key: 'purposePort'
            }, {
                label: this.$t('fbb.headlogistics.voyage_name', { defaultValue: '船名航次' }),
                key: 'voyageName'
            }, {
                label: this.$t('fbb.headlogistics.transport_type', { defaultValue: '发运方式' }),
                key: 'transportType',
                options: this.gettransportType
            }, {
                label: this.$t('fbb.headlogistics.actual_loading_date', { defaultValue: '实际装柜日期' }),
                key: 'actualLoadingDate'
            }, {
                label: this.$t('fbb.headlogistics.actual_sail_at', { defaultValue: '实际开船日期' }),
                key: 'actualSailAt'
            }, {
                label: this.$t('fbb.headlogistics.expect_port_arrival_date', { defaultValue: '预计到港日期' }),
                key: 'expectPortArrivalDate'
            }, {
                label: this.$t('fbb.headlogistics.expect_warehouse_arrval_date', { defaultValue: '预计到仓日期' }),
                key: 'expectWarehouseArrivalDate'
            }, {
                label: this.$t('fbb.headlogistics.arrive_at', { defaultValue: '实际到港日期' }),
                key: 'arriveAt'
            }, {
                label: '最新预计到仓时间',
                key: 'newestEstimateArriveDate',
                show: this.getShowNewStatus(this.formData.orderStatus)
            }, {
                label: this.$t('fbb.headlogistics.appointment_at', { defaultValue: '预约送仓时间' }),
                key: 'appointmentAt'
            }, {
                label: this.$t('fbb.headlogistics.stock_in', { defaultValue: '妥投日期' }),
                key: 'stockinAt'
            }, {
                label: this.$t('fbb.headlogistics.attach_sail_order', { defaultValue: '提单' }),
                key: 'attachSailOrder',
                render: (h) => {
                    let result
                    if (this.formData.attachSailOrderUrl) {
                        result = h('div', {
                            class: 'color-primary',
                            on: {
                                click: () => {
                                    this.handleWebfs(this.formData.attachSailOrderUrl, 'download')
                                }
                            }
                        }, this.formData.attachSailOrder)
                        return result
                    }
                    else {
                        return <div>--</div>
                    }
                }
            }, {
                label: this.$t('fbb.headlogistics.attach_src_invoice', { defaultValue: '发票' }),
                key: 'attachSrcInvoice',
                render: (h) => {
                    let result
                    if (this.formData.attachUrlInvoice) {
                        result = h('div', {
                            class: 'color-primary',
                            on: {
                                click: () => {
                                    this.handleWebfs(this.formData.attachUrlInvoice, 'download')
                                }
                            }
                        }, this.formData.attachSrcInvoice)
                        return result
                    }
                    else {
                        return <div>--</div>
                    }
                    
                }
            }, {
                label: this.$t('fbb.headlogistics.invoice_confirm_at', { defaultValue: '发票确认时间' }),
                key: 'invoiceConfirmAt'
            }]
        },
        getImporter () {
            return [{
                label: this.$t('fbb.headlogistics.import_name', { defaultValue: '进口商名称' }),
                key: 'receiverCompanyName'
            }, {
                label: this.$t('fbb.headlogistics.receiver', { defaultValue: '收货人' }),
                key: 'receiverContact'
            }, {
                label: this.$t('fbb.headlogistics.address_detail', { defaultValue: '详细地址' }),
                key: 'receiverAddress'
            }, {
                label: this.$t('fbb.headlogistics.receiver_phone', { defaultValue: '移动电话' }),
                key: 'receiverPhone'
            }, {
                label: this.$t('fbb.headlogistics.receiver_telephone', { defaultValue: '固定电话' }),
                key: 'receiverTelephone'
            }, {
                label: this.$t('fbb.headlogistics.receiver_fax', { defaultValue: '传真' }),
                key: 'receiverFax'
            }, {
                label: this.$t('fbb.headlogistics.receiver_note', { defaultValue: '其他联系方式' }),
                key: 'receiverNote'
            }]
        },
        inboundcolumns(){
            return [
                {
                    title: 'No.',
                    type:"index",
                },
                {
                    title: 'SKU',
                    key: "sku",
                },
                {
                    title: this.$t('fbb.headlogistics.custom_cn_name', { defaultValue: '报关品名(中文)' }),
                    key: "name",
                },
                {
                    title: this.$t('fbb.headlogistics.custom_en_name', { defaultValue: '报关品名(英文)' }),
                    key: "nameEn",
                },
                {
                    title: this.$t('fbb.headlogistics.hscode', { defaultValue: '目的国HSCode' }),
                    key:"hscode",
                },
                {
                    title: this.$t('fbb.headlogistics.quantity', { defaultValue: '装箱入数' }),
                    key: "quantity",
                },
                {
                    title: this.$t('fbb.inbound.outer_box_size', { defaultValue: '外箱长宽高(cm)' }),
                    render:(h,{row})=>{
                        return <div>{row.length} * {row.width} * {row.height}</div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.carton_weight', { defaultValue: '单箱毛重' }) + '(kg)',
                    key: "weight",
                },
                {
                    title: this.$t('fbb.headlogistics.carton_volumn', { defaultValue: '单箱体积' }) + '(CBM)',
                    key:"volume",
                },
                {
                    title: this.$t('fbb.inbound.cases', { defaultValue: '箱数' }),
                    key: "boxQty",
                },
                {
                    title: this.$t('fbb.headlogistics.total_weight', { defaultValue: '总重量' }) + '(kg)',
                    key: "weightTotal",
                },
                {
                    title: this.$t('fbb.headlogistics.total_volumn', { defaultValue: '总体积' }) + '(CBM)',
                    key: "volumeTotal",
                },
            ]
        },
        doccolumns(){
            return [
                {
                    label: 'No.',
                    type:"index",
                },
                {
                    label: this.$t('global.common.attachment_type', { defaultValue: '附件类型' }),
                    type:"index",
                },
                {
                    label: this.$t('global.common.attachment_name', { defaultValue: '附件名称' }),
                    key: "inboundPlanOrderStatus",
                },
                {
                    label: this.$t('global.common.attachment_url', { defaultValue: '附件链接' }),
                    key: "inboundPlanOrderStatus",
                },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: "inboundPlanOrderStatus",
                },
            ]
        },
    },
    methods:{
        refreshPage () {
            this.loading = true
            this.needRefresh = false
            this.update()
            // window.location.reload(0)
        },
        getOrderStatus (status) {
            if (status === undefined) return
            return this.queryOrderStatusList.filter(item => {
                return status === item.value
            })[0].label
        },
        getException (item) {
            if (!item.exceptionStatus) return {}
            let result = {}
            // 直达
            if (this.formData.logisticsType === 'through') {
                result = this.exceptionItem
            }
            // 转运
            else {
                result = this.exceptionStatus.filter(exceptionItem => {
                    return item.exceptionStatus === exceptionItem.value
                })[0]
            }
            console.log(item, result)
            return result
        },
        exportExcel () {
            this.operate = {
                show: true,
                title: this.$t('fbb.headlogistics.export_order', { defaultValue: '导出订舱单' }),
                component: 'compExportExcel',
                // width: 900,
                props: {
                    originData: this.formData
                }
            }
        },
        changeFlag(code,index){
            this.inboundlist[index].flag = true
            let itemjson = this.addressCodeList.filter(item=>{
                return item.code == code
            })[0]
            this.inboundlist[index].addressEntity.country = itemjson.country
            this.inboundlist[index].addressEntity.state = itemjson.state
            this.inboundlist[index].addressEntity.city = itemjson.city
            this.inboundlist[index].addressEntity.address = itemjson.address
            this.inboundlist[index].addressEntity.linkman = itemjson.linkman
            this.inboundlist[index].addressEntity.phone = itemjson.phone
            // this.inboundlist[index].flag
        },
        update(needClose){
            if (needClose) {
                this.operate.show = false
            }
            if(this.querytype){
                this.id = this.activeid
                this.type = this.querytype
            }else{
                this.id = this.$route.query.id
                this.type = this.type
            }
            if(this.type == 'add') return
            if(this.type == 'edit'){
                HttpAddressList({
                    'search[EQ_warehouseType]':2,
                    rows: 10000,
                }).then(res=>{
                    this.addressCodeList = res.data.content
                },err=>{
                    this.$VMessage.error(err.message);
                })
            }
            HttpSeeLogisticsOne({
                orderId:this.id
            }).then(res=>{
                this.formData = res.data
                this.inboundlist = res.data.subLogisticsHeadParams
                this.factorylist = res.data.logisticsContactRequests
                this.$nextTick(() => {
                    this.needRefresh = true
                })
                this.exceptionItem = this.exceptionStatus.filter (item => {
                    return this.formData.exceptionStatus === item.value
                })[0]
                if (this.formData.exceptionStatus !== 0) {
                    this.isNormal = false
                }
                this.btnList = this.buttonList(this.formData.carrierType, this.formData.logisticsType, this.formData.orderStatus, this.isNormal, this.formData.invoiceStatus, false, this.formData.podStatus)
                this.hasData = true
                this.loading = false
            },err=>{
                this.$VMessage.error(err.message);
            })
        },
        async submit(){
            if (! await this.$refs["editform"].validate()) {
                return 
            }
            
            let dataflag;
            // 验证必填
            this.factorylist.map(item=>{
                if(item.factoryName==''||item.factoryAddress==''||item.factoryContact==''||item.factoryPhone==''||item.senderName==''||item.senderAddress==''||item.senderContact==''||item.senderPhone==''){
                    dataflag = true
                }
            })
            if(dataflag){
                this.$VMessage.error(this.$t('fbb.headlogistics.info_empty', { defaultValue: '必填项不能为空' }));
                return;
            }

            // 判断页面的目的仓是否填写
            let flag = false;
            this.inboundlist.map(item=>{
                if(item.addressCode == ''){
                    flag = true
                }
            })

            if(flag){
                this.$VMessage.error(this.$t('fbb.headlogistics.target_empty', { defaultValue: '目的仓库不能为空' }))
                return
            }

            this.formData.subOrderRequestList = this.inboundlist
            this.formData.subOrderRequestList.forEach((item) => {
                            item.subOrderNo = item.orderNo;
                        })
            this.formData.logisticsContactRequests = this.factorylist
            HttpUpdateLogisticsOne({
                logisticsHeadId:this.id,
                orgId:global.SYSID,
                ...this.formData,
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.cancel()
            },err=>{
                this.$VMessage.error(err.message);
            })
        },
        submitshenhe(){

            let dataflag;
            // 验证必填
            this.factorylist.map(item=>{
                if(item.factoryName==''||item.factoryAddress==''||item.factoryContact==''||item.factoryPhone==''||item.senderName==''||item.senderAddress==''||item.senderContact==''||item.senderPhone==''){
                    dataflag = true
                }
            })
            if(dataflag){
                this.$VMessage.error(this.$t('fbb.headlogistics.info_empty', { defaultValue: '必填项不能为空' }));
                return;
            }
            
            // 判断页面的目的仓是否填写
            let flag = false;
            this.inboundlist.map(item=>{
                if(item.addressCode == ''){
                    flag = true
                }
            })

            if(flag){
                this.$VMessage.error(this.$t('fbb.headlogistics.target_empty', { defaultValue: '目的仓库不能为空' }))
                return
            }

            this.formData.subOrderRequestList = this.inboundlist
            this.formData.subOrderRequestList.forEach((item) => {
                item.subOrderNo = item.orderNo;
            })
            this.formData.logisticsContactRequests = this.factorylist
            HttpSubmitSaveLogisticsOne({
                logisticsHeadId:this.id,
                orgId:global.SYSID,
                ...this.formData,
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.cancel()
                this.$emit('on-close')
            },err=>{
                this.$VMessage.error(err.message);
            })
        },
        cancel(){
            this.$router.push({
				name: 'headlogiticsList'
			})
        },
        closeModal () {
            this.$emit('on-close')
        },
        handleOperate (item, isSub) {
            // // 提交
            // if (item.tag === 0) {
            //     return this.operate = {
            //         show: true,
            //         title: '提交',
            //         contentText: '确定提交？',
            //         ok: () => {
            //             HttpUpdateLogistics({
            //                 headId: this.formData.id,
            //                 isSub: false,
            //                 type: item.type,
            //                 content: {},
            //                 attachments: [],
            //                 remark: ''
            //             }).then(res => {
            //                 this.$VMessage.success(res.message)
            //                 this.operate.show = false
            //             }, err => {
            //                 this.$VMessage.error(err.message)
            //             })
            //         }
            //     }
            // }
            // 返回
            if (item.tag === 15) {
                return this.$emit('on-close')
            }
            // 发船重推
            if (item.tag === 20) {
                return HttpUpdateLogistics({
                    headId: this.formData.id,
                    isSub: false,
                    content: {},
                    type: 51
                }).then(res => {
                    this.$VMessage.success(res.message)
                    this.refreshPage()
                }, err => {
                    this.$VMessage.error(err.message)
                })
            }
            this.operate = {
                show: true,
                title: item.title ? item.title: item.text,
                component: item.component,
                width: item.width,
                props: {
                    isSub: isSub,
                    operateType: item.type,
                    carrierType: this.formData.carrierType, 
                    logisticsType: this.formData.logisticsType,
                    orderStatus: this.formData.orderStatus,
                    ...item.data,
                    originData: this.formData
                }
            }
        }
    }
}
</script>



